export class LayoutTranslationConfig {
  public layoutTranslations: any;
  public navLabelTranslations: any;
}
